enum StatusAsAuthKey {
  SUCCESS = 'success',
  PENDING = 'pending',
}

export default StatusAsAuthKey;
